import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { Button, Heading, useMediaQuery } from "@rshbintech.dboul/core-ui";
import {
  Close as CloseIcon,
  Settings as SettingsIcon,
} from "@rshbintech.dboul/icons";
import { useAppTranslation } from "../../../../hooks";
import { NOTIFICATIONS_SERVICES_PATHNAME } from "./constants";
import { NotificationsHeaderProps } from "./types";
import styles from "./styles.scss";

export const NotificationsHeader = ({
  className,
  isServiceManagementAvailable,
  onCloseNotificationsPopup,
}: NotificationsHeaderProps) => {
  const navigate = useNavigate();
  const isExtraLargeDesktop = useMediaQuery("xl");
  const { translate } = useAppTranslation("NOTIFICATION");

  const iconSize = isExtraLargeDesktop ? "large" : "medium";

  const handleNavigateToNotificationServices = () => {
    onCloseNotificationsPopup();
    navigate(NOTIFICATIONS_SERVICES_PATHNAME);
  };

  const ariaLabels = {
    NOTIFICATION_SERVICES_BUTTON: translate(
      "ARIA_LABELS.NOTIFICATION_SERVICES_BUTTON"
    ),
    CLOSE_NOTIFICATIONS: translate("ARIA_LABELS.CLOSE_NOTIFICATIONS"),
  };

  return (
    <header className={cn(styles.header, className)}>
      <Heading className={styles.title} level={4}>
        {translate("TITLE")}
      </Heading>
      <div className={styles["buttons-container"]}>
        {isServiceManagementAvailable && (
          <Button
            type="icon"
            htmlType="button"
            aria-label={ariaLabels.NOTIFICATION_SERVICES_BUTTON}
            onClick={handleNavigateToNotificationServices}
          >
            <SettingsIcon size={iconSize} />
          </Button>
        )}
        <Button
          type="icon"
          htmlType="button"
          aria-label={ariaLabels.CLOSE_NOTIFICATIONS}
          onClick={onCloseNotificationsPopup}
          data-rptracker-event="click"
          data-rptracker-category="notifications"
          data-rptracker-action="notificationsClose"
        >
          <CloseIcon size={iconSize} />
        </Button>
      </div>
    </header>
  );
};
